import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import cn from './LabelHint.module.scss'

interface LabelHintProps {
  text: string
}

function LabelHint({ text }: LabelHintProps) {
  return (
    <Tooltip title={text} placement="topLeft">
      <QuestionCircleOutlined className={cn.icon} aria-label={text} />
    </Tooltip>
  )
}

export default LabelHint
